/* tslint:disable */
/* eslint-disable */
/**
 * Lumen Failure Management API
 * <h5>ToDo: API description</h5>
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateRoleDto
 */
export interface CreateUpdateRoleDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateRoleDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateRoleDto
     */
    description?: string | null;
}

export function CreateUpdateRoleDtoFromJSON(json: any): CreateUpdateRoleDto {
    return CreateUpdateRoleDtoFromJSONTyped(json, false);
}

export function CreateUpdateRoleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateRoleDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
    };
}

export function CreateUpdateRoleDtoToJSON(value?: CreateUpdateRoleDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
    };
}


